if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    hide() { super.hide(); }
    show(opener) {
      this.setupNavigation();
      super.show(opener);
      this.showActiveMedia();
      this.updateNavigation();
    }
    setupNavigation() {
      if (this.navigation) return;
      const labels = {en:['Previous image','Next image'],de:['Vorheriges Bild','Nächstes Bild'],fr:['Image précédente','Image suivante']}[document.documentElement.lang.slice(0,2)] || ['Previous image','Next image'];
      this.navigation = document.createElement('div');
      this.navigation.addEventListener('pointerup', event => event.stopPropagation());
      this.querySelector('.product-media-modal__content').style.paddingBottom = '8rem';
      this.mediaItems().filter(item => item.tagName === 'IMG').forEach(item => { item.style.maxHeight = 'calc(100dvh - 14rem)'; });
      this.navigation.style.cssText = 'position:fixed;bottom:12px;left:50%;transform:translateX(-50%);z-index:3;display:flex;align-items:center;gap:16px;background:#fff;color:#25352c;border:1px solid #ddd;border-radius:30px;padding:4px 8px;box-shadow:0 3px 16px #0001';
      [-1,1].forEach((direction,index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label',labels[index]);
        button.textContent = direction < 0 ? '←' : '→';
        button.style.cssText = 'width:44px;height:44px;border:0;border-radius:50%;background:#f4f3ee;color:inherit;font:24px sans-serif;cursor:pointer';
        button.addEventListener('click',() => this.moveMedia(direction));
        this.navigation.append(button);
      });
      this.counter = document.createElement('span');
      this.counter.setAttribute('aria-live','polite');
      this.counter.style.cssText = 'min-width:48px;text-align:center;font:14px sans-serif';
      this.navigation.insertBefore(this.counter,this.navigation.lastChild);
      this.querySelector('[role="dialog"]').append(this.navigation);
      this.addEventListener('keydown',(event) => {
        if (!this.hasAttribute('open') || event.target.closest('input,textarea,select,video,model-viewer')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.moveMedia(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
    }
    mediaItems() {
      return Array.from(this.querySelector('.product-media-modal__content').children).filter(item => item.hasAttribute('data-media-id'));
    }
    updateNavigation() {
      const items = this.mediaItems();
      const index = items.findIndex(item => item.classList.contains('active'));
      this.navigation.style.display = items.length > 1 ? 'flex' : 'none';
      this.counter.textContent = (index + 1) + ' / ' + items.length;
    }
    moveMedia(direction) {
      const items = this.mediaItems();
      if (items.length < 2) return;
      const index = items.findIndex(item => item.classList.contains('active'));
      const next = items[(index + direction + items.length) % items.length];
      if (typeof pauseAllMedia === 'function') pauseAllMedia();
      items.forEach(item => item.classList.toggle('active',item === next));
      if (next.tagName === 'IMG') next.loading = 'eager';
      if (typeof next.loadContent === 'function') next.loadContent();
      const content = this.querySelector('.product-media-modal__content');
      content.scrollTop = 0;
      content.scrollLeft = 0;
      this.updateNavigation();
    }
    showActiveMedia() {
      const id = this.openedBy.getAttribute('data-media-id');
      const activeMedia = this.mediaItems().find(item => item.getAttribute('data-media-id') === id);
      if (!activeMedia) return;
      this.mediaItems().forEach(item => item.classList.toggle('active',item === activeMedia));
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.scrollIntoView();
      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
      if (activeMedia.nodeName === 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube')) activeMedia.loadContent();
    }
  });
}
